import { IApp } from "@/interfaces";
import { DigitalHumanSetting } from "@/store/modules/digital_human/interfaces";
const logo_config: any = {
  [IApp.Portals.KU]: require("@/assets/icons/ku_logo.png")
};
import { LanguageKey } from "@/store/modules/common/interfaces";

const digital_human_setting: Record<string, DigitalHumanSetting> = {
  [IApp.Portals.HCMS]: {
    bot_avatar: "Kayla-incasualsuit-20220818",
    bot_voice_id: "2f72ee82b83d4b00af16c4771d611752",
    welcome_message:
      "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!",
    intro_popup: {
      title: "AI HR Office Assistant",
      message:
        "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: "130",
    height: "130"
  },
  [IApp.Portals.KU]: {
    bot_avatar: "Kayla-incasualsuit-20220818",
    bot_voice_id: "2f72ee82b83d4b00af16c4771d611752",
    welcome_message:
      "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!",
    intro_popup: {
      title: "AI HR Office Assistant",
      message:
        "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: "130",
    height: "130"
  },
  [IApp.Portals.COREHCMS]: {
    bot_avatar: "Kayla-incasualsuit-20220818",
    bot_voice_id: "2f72ee82b83d4b00af16c4771d611752"
  },
  [IApp.Portals.COREHCS]: {
    bot_avatar: "Kayla-incasualsuit-20220818",
    bot_voice_id: "2f72ee82b83d4b00af16c4771d611752"
  }
};

export default digital_human_setting;
